import TurnDownService from 'turndown'

export const turndownService = new TurnDownService()
export default turndownService
